const dallas = { id: 2, type: "handleStyle", label: "Dallas Lever" };

const pull = { id: 1, type: "handleStyle", label: "Handle Pull" };

const handlePull = [
    { id: 1, type: "handleStyle", label: "Axis" },
    { id: 2, type: "handleStyle", label: "Crest" },
    { id: 3, type: "handleStyle", label: "Monarch" },
    { id: 4, type: "handleStyle", label: "Vector" },
    { id: 5, type: "handleStyle", label: "Strata" },
    { id: 6, type: "handleStyle", label: "Forge" },
];

const byOthers = { id: 1, type: "handleStyle", label: "Handle Pull by Others" };

const smartLock = { id: 1, type: "handleStyle", label: "Smart Lock *" };

export { dallas, byOthers, smartLock, handlePull, pull };
